export enum AdminEvents {
  "userAccountCreated" = "USER_ACCOUNT_CREATED",
  "userAccountUpdated" = "USER_ACCOUNT_UPDATED",
  "userAccountDeleted" = "USER_ACCOUNT_DELETED",
  "userJoinedOrganization" = "USER_JOINED_ORGANIZATION",
  "userLeaveOrganization" = "USER_LEAVE_ORGANIZATION",
}
